// extracted by mini-css-extract-plugin
export var Link = "styles-module--Link--QvCUP";